import { AfterViewInit, Component, ElementRef, OnDestroy, Renderer2, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SafeHtml } from '@angular/platform-browser';
import { AnimatedModalComponent } from '@app/shared/modals/animated-modal.component';

@Component({
  selector: 'app-selfie-modal',
  template: `
    <div class="capture-content">
      <a
        href="#"
        (click)="$event.preventDefault(); reject(); stop()"
        class="icon close-popup"
        data-id="modalAlert-close-button"
      >
        <i class="fal fa-times"></i>
      </a>
      <div class="hidden-holder" [class.visible]="initiliaze && !cameraNotAllowed">
        <div class="capturer">
          <div class="outer">
            <div class="video">
              <canvas class="video-capture" #canvasElement [class.visible]="captured"></canvas>
              <video class="video-capture" autoplay #videoElement [class.visible]="!captured"></video>
              <div class="loader" *ngIf="!allowCapture">
                <app-loader [isLoading]="true"></app-loader>
                <br /><br />
                Waiting for your camera. Make sure your browser is not blocking it.
              </div>
            </div>
          </div>
          <div class="buttons">
            <ng-container *ngIf="!captured">
              <app-form-button class="primary width-100" (click)="capture()" [disabled]="!allowCapture"
                >Capture</app-form-button
              >
            </ng-container>
            <ng-container *ngIf="captured">
              <app-form-button (click)="captured = false">Retry</app-form-button>
              <app-form-button class="primary" (click)="submit()">Submit</app-form-button>
            </ng-container>
          </div>
        </div>
      </div>
      <ng-container *ngIf="!initiliaze">
        <div class="init-content">
          <p>
            We ask our customer to make selfie while holding uploaded document in their hand. <br />Your face and
            document must be fully seen and readable this photo.<br />
            Please click start and, when prompted, allow browser camera to proceed.
          </p>
          <app-form-button class="primary width-100" (click)="initializeCamera()">Start</app-form-button>
        </div>
      </ng-container>
      <ng-container *ngIf="cameraNotAllowed">
        <div class="init-content">
          <p>
            Camera does not have permissions to be runt on this website. Please allow it, try refreshing page or
            changing browsers and trying again.
          </p>
          <app-form-button class="primary width-100" (click)="initializeCamera()">Start</app-form-button>
        </div>
      </ng-container>
    </div>
  `,
  styles: [
    `
      :host {
        width: 100%;
      }
      .hidden-holder {
        display: none;
      }
      .hidden-holder.visible {
        display: block;
      }
      .capture-content {
      }
      .video-capture {
        width: 100%;
        height: auto;
      }
      .outer {
        position: relative;
      }
      .outer:before {
        display: block;
        content: '';
        width: 100%;
        padding-top: (9 / 16) * 100%;
      }
      .outer:before > .inner {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
      }
      /*.capturer {*/
      /*  height: 100%;*/
      /*  position: fixed;*/
      /*  width: 100%;*/
      /*  top: 50%;*/
      /*  left: 50%;*/
      /*  transform: translate(-50%,-50%);*/
      /*  !*padding: 15px;*!*/
      /*}*/
      .close-popup {
        font-size: 35px;
        top: 10px;
        right: 10px;
      }
      .capture-btn {
        width: 100%;
        height: 40px;
        font-size: 18px;
        margin-top: -3px;
      }
      .video-capture {
        display: none;
      }
      .video-capture.visible {
        display: block;
      }
      .init-content {
        padding: 40px;
      }
      .buttons {
        text-align: right;
      }
      .loader {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-align: center;
      }
    `,
  ],
})
export class SelfieCaptureModalComponent extends AnimatedModalComponent implements AfterViewInit, OnDestroy {
  hero: string;
  title: string;
  text: string | SafeHtml;
  ok: string;
  cancel: string | null;

  initiliaze: boolean = false;
  allowCapture: boolean = false;
  captured: boolean = false;

  cameraNotAllowed: boolean = false;

  private _constraints = { video: true };
  private _localMediaStream: MediaStream;
  private _capturedImage: string;

  @ViewChild('videoElement') videoElement: ElementRef;
  @ViewChild('canvasElement') canvasElement: ElementRef;
  constructor(private ref: NgbActiveModal, protected elRef: ElementRef, protected renderer: Renderer2) {
    super(elRef, renderer);
  }

  ngAfterViewInit(): void {}

  ngOnDestroy(): void {
    this.stop();
  }

  public close(): void {
    this.ref.close();
  }

  public reject(): void {
    this.ref.dismiss();
  }

  public submit(): void {
    this.ref.close({ image: this._capturedImage });
  }

  public capture(): void {
    const canvas: HTMLCanvasElement = this.canvasElement.nativeElement;
    const video: HTMLVideoElement = this.videoElement.nativeElement;
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    canvas.getContext('2d').drawImage(video, 0, 0);
    this._capturedImage = canvas.toDataURL('image/png');
    this.captured = true;
  }

  public stop(): void {
    if (this.videoElement && this.videoElement.nativeElement) {
      this.videoElement.nativeElement.pause();
    }
    if (!this._localMediaStream) {
      return;
    }
    try {
      this._localMediaStream.stop();
    } catch (e) {
      for (const track of this._localMediaStream.getVideoTracks()) {
        track.stop();
      }
    }
  }

  private handleCameraSuccess(stream: MediaStream): void {
    this.allowCapture = true;
    this.cameraNotAllowed = false;
    this._localMediaStream = stream;
    this.videoElement.nativeElement.srcObject = stream;
  }

  private handleError(error: Error): void {
    this.cameraNotAllowed = true;
  }

  initializeCamera() {
    this.initiliaze = true;
    window.navigator.mediaDevices
      .getUserMedia(this._constraints)
      .then(this.handleCameraSuccess.bind(this))
      .catch(this.handleError.bind(this));
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/modals/selfie-capture-modal.component.ts